import React from 'react'
import style from "./CompensationCase.module.css";

const Evidence = ({index, key_name, handleInput, data, tab, consult, showFiles, getShowFiles}) => {

  return (

    <div className={style.add_txt}>
      <div className={style.item_input_text}>
        <p className={style.tit}>자료명</p>
        <input type="text" name={`${key_name}_case`} data-index={index} placeholder='' value={data?.case} onChange={handleInput} />
      </div>

      <div className={style.item_input_text}>
        <p className={style.tit}>내용 <span className={style.small}>(사건 관련성)</span></p>
        <div className={style.item_input_textarea}>
          <textarea name={`${key_name}_content`} data-index={index} value={data?.content} onChange={handleInput}/>
        </div>
      </div>

      <div className={style.item_input_text}>
        <p className={style.tit}>취득 경위</p>
        <input type="text" name={`${key_name}_obtain`} data-index={index} placeholder='' value={data?.obtain} onChange={handleInput} />
      </div>

      {/* <FileInput index={index} consult={consult} handleInput={handleInput} showFiles={showFiles} getShowFiles={getShowFiles} /> */}
    </div>

  )
}

export default Evidence
